import React from 'react'
import { Form, FormGroup, InputGroup, Button, Input, Label } from 'reactstrap'
import Loader from 'react-loader-spinner'
import Select from 'react-select';
import '../../../stylesheets/Provision.css'
import '../../../stylesheets/example.css'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { TOKEN_STORAGE_KEY, getStorage } from "../../../dataHelpers/authenticationHelpers"
import { AppError } from "../../../models"
import { ErrorModal } from './../../ui'
import Invoice from './Invoice'
import {getAllTeams, RESPONSE_PAGE_SIZE, shareSubscriptionQuote, getTeamsByQuoteNumber} from "../../../api"
import { subscriptionHelpers } from '../../../dataHelpers';
import $ from 'jquery';
import { NO_TEAM, SELECT_TEAM, TEAM_NOT_FOUND, INVALID_QUOTE } from '../../../constants'

class InvoiceForSupport extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            errors: [],
            loading: false,
            invoiceTeamId: '',
            teams: [{ label: 'Loading...', value: '' }],
            removeSelected: true,
            stayOpen: false,
            value: [],
            invoiceNumber: [],
            placeholder: 'Loading...',
            enableDownload: false,
            selectOptionType: 'Invoice',
            allControllerIds: [],
            quoteControllersIds: [],
        }
        this.token = (props.token || JSON.parse(getStorage().getItem(TOKEN_STORAGE_KEY)))
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleSelectChange = this.handleSelectChange.bind(this)
        this.downloadDocument = this.downloadDocument.bind(this)
        this.isDataFoundForDownload = this.isDataFoundForDownload.bind(this)
        this.handleOptionTypeChange = this.handleOptionTypeChange.bind(this)
        this.handleSubmitQuote = this.handleSubmitQuote.bind(this)
        this.allControllerIdGet = this.allControllerIdGet.bind(this)
        
    }

    async componentDidMount() {
        this.fetchTeamsState(this.token)
    }

    async isDataFoundForDownload() {
        this.setState({ enableDownload: true })
    }

   
    async downloadDocument() {
        let dealerTeamId = this.state.value
        let typeQuote = false
        if(this.state.selectOptionType == "Quote"){
            typeQuote = true
        }
        let show_print_button = (counter) => {
            setTimeout(function () {
                $('#print_pay_btn' + counter).css("display", "inline");
                $('.noprint').css("display", ""); 
                $('.form-check-input').css("display", "block");
               
            }, 3000);
        }
        if (dealerTeamId == '') {
            let appError = new AppError(NO_TEAM, SELECT_TEAM)
            await this.setState({ errors: [appError], loading: false })
        } else {
            var teamId_array = dealerTeamId.split(',');
            var teamData = this.state.teams
            let invoiceNo = this.state.invoiceNumber
            var counter = 0;
            var accessToken = this.token
            $('.invoice-top').each(function () {
                let teamResults = (teamData).filter(e => e.value === parseInt(teamId_array[counter]))
                let teamName = teamResults[0].label
                let downloadInvoiceNo = teamName + '-' + invoiceNo[counter]
                try {
                    let invoiceData
                    let downloadType = "Invoice"
                    if(typeQuote){
                        var checkboxesId = document.getElementsByName('subscriptionid' + counter + '[]')
                        var checkboxes = document.getElementsByName('subscription' + counter + '[]')
                        downloadType = "Quote"
                        
                        let listControllers = []
                        
                        for (var j in checkboxesId) {
                            if (checkboxesId[j].value && checkboxes[j].checked == true) {
                                var idArray = checkboxesId[j].value.split(',');
                                let selectChkId = idArray[0]
                                
                                listControllers.push(selectChkId);
                            }
                        }

                        console.log(listControllers)
                        invoiceData = subscriptionHelpers.createDownloadInvoice(accessToken, teamId_array[counter], invoiceNo[counter], downloadInvoiceNo, downloadType, listControllers)
                    }else{
                        invoiceData = subscriptionHelpers.createDownloadInvoice(accessToken, teamId_array[counter], invoiceNo[counter], downloadInvoiceNo)
 
                    }
                    
                    if (!invoiceData.error) {

                        $('#print_pay_btn' + counter).css("display", "none"); // hide print & pay button
                        $('.form-check-input').css("display", "none"); // hide all checkboxes
                        $('.noprint').css("display", "none"); // hide unchecked rows
                        var input = $(document).find('#pdfcount' + counter).get(0);

                        show_print_button(counter); // show all checkboxes and print pay button             
                        html2canvas(input)
                            .then((canvas) => {
                                const imgData = canvas.toDataURL('image/png');
                                const pdf = new jsPDF('p', 'pt', 'letter');
                                pdf.addImage(imgData, 'JPEG', 0, 25);
                                pdf.save(downloadInvoiceNo);
                            });
                        counter++;
                    } else {
                        console.log(invoiceData.error)
                        //this.setState({ errors: [invoiceData.error], loading: false })
                    }
                } catch (error) {
                    console.log(error)
                }
            });
        }
    }

    async fetchTeamsState(token) {
        try {
            let { results } = await getAllTeams(token, true, true, false, true, 1, 10000)
            //results = results.filter(e => e.dealership == true)
            let newResults = results.map(({
                id: value, name: label, ...rest }) => ({
                    value, label, ...rest
                })); // Replace key id by value & name by label
            this.setState({ teams: newResults, loading: false, placeholder: 'Select Team' })
        } catch (error) {
            this.setState({ teams: [{ label: TEAM_NOT_FOUND, value: '' }], loading: false, placeholder: TEAM_NOT_FOUND })
            console.log(error)
        }
    }

    handleOptionTypeChange(e) {
        this.setState({selectOptionType: e.target.value, invoiceTeamId: '',
         enableDownload: false, value: []});
    }

    


    handleSelectChange(value) {
        this.setState({
            value,
            invoiceTeamId: '',
            enableDownload: false
        });
    }
    async handleSubmitQuote(e) {
        e.preventDefault()
        this.setState({loading: true})
        let dealerTeamId = this.state.value;
        console.log(e.target['email'].value)
        console.log(this.state.allControllerIds)
        console.log(dealerTeamId)
        
        let email = e.target['email'].value
        let controllerIDs = this.state.allControllerIds
        let invoiceNumber = this.state.invoiceNumber
        
        let accessToken = this.token
        let selectedIds = []

        if (dealerTeamId == '') {
            let appError = new AppError(NO_TEAM, SELECT_TEAM)
            await this.setState({ errors: [appError], loading: false })
            return
        } 

        if (!email || !email.length) {
            let appError = new AppError("No Email Specified", `Please enter a user's email address to share Quote.`)
            await this.setState({errors: [appError], loading: false})
            return
        }
        if (!controllerIDs || !controllerIDs.length) {
            let appError = new AppError("No Controlers Selected", `Please select atleast one controller.`)
            await this.setState({errors: [appError], loading: false})
            return
        }
        
        Object.keys(controllerIDs).forEach(function(key) {
            selectedIds.push(controllerIDs[key]['id'])
            
          })

        try {
            let invoiceData = await shareSubscriptionQuote(accessToken, selectedIds, invoiceNumber, email, false, dealerTeamId)
            if(invoiceData['status'] == 1){
                alert("Quote shared successfully with customer")
            }
            
            this.setState({loading: false})
        } catch (error) {
            console.log(error)
            this.setState({loading: false})
        }

    }
    allControllerIdGet(valuesArr){
        this.setState({allControllerIds: valuesArr});
    }

    async handleSubmit(e) {
        e.preventDefault()
        this.setState({ loading: true })
        try {
            let dealerTeamId = this.state.value;
            let optionType = this.state.selectOptionType
            let quote_number
            let quoteControllers = []
            
            if(optionType == "Invoice From Quote")
            {
                quote_number = e.target['quote_number'].value
                let accessToken = this.token
                
                let teams = await getTeamsByQuoteNumber(accessToken, quote_number)
                dealerTeamId = teams['teams_list'].toString()
                quoteControllers = teams['controllers']
                console.log('dealerTeamId')
                console.log(teams['teams_list'].length)
                if (teams['teams_list'].length == 0) {
                    let appError = new AppError(INVALID_QUOTE, INVALID_QUOTE)
                    await this.setState({ errors: [appError], loading: false })
                }else{
                    this.setState({
                        value: dealerTeamId
                    })
                }
            }
            
            if (dealerTeamId == '' && optionType != "Invoice From Quote") {
                let appError = new AppError(NO_TEAM, SELECT_TEAM)
                await this.setState({ errors: [appError], loading: false })
            } else {
                let invoiceNumberArr = []
                let teamIdArr = dealerTeamId.split(',')
                
                for(let tid =0 ; tid < teamIdArr.length; tid++){
                    if(optionType == "Invoice From Quote")
                    {   
                        
                        invoiceNumberArr.push(quote_number)
                    }else{
                        invoiceNumberArr.push(Math.floor(1000000000 + Math.random() * 9000000000)+tid)
                    }
                }
                
                this.setState({
                    invoiceTeamId: dealerTeamId, loading: false,
                    invoiceNumber: invoiceNumberArr,
                    quoteControllersIds: quoteControllers
                })
            }
        } catch (error) {
            console.log(error)
        }
    }

    dismissError(error) {
        let errors = this.state.errors.filter((e) => e !== error)
        this.setState({ errors, loading: false })
    }

    render() {
        let { loading, errors, stayOpen, value, teams, removeSelected, invoiceTeamId, placeholder, enableDownload, selectOptionType, quoteControllersIds } = this.state
       
        return (<div>
            <div className="row justify-content-center align-items-center">
                <h1 className="col-12 noprint">Generate Invoice/Quote For Support</h1>
                {errors.map((appError, idx) =>
                    <ErrorModal key={`error-${appError.text}-${idx}`}
                        modal={true}
                        toggle={() => (this.dismissError(appError))}
                        text={appError.text}
                        title={appError.title} />
                )}
                    <br />
                    
                {(loading ?
                    <Loader type="TailSpin" width={60} height={60} /> :
                    
                    <Form onSubmit={this.handleSubmit} className="col-lg-5 col-md-8 col-sm-10 noprint">
                        <FormGroup>
                            <br />
                            <InputGroup>
                            <Input type="select" 
                                    onChange={this.handleOptionTypeChange}>
                                    <option key={'key-invoice-select'} value={'Invoice'} selected={selectOptionType == "Invoice"? true: false} >
                                        &ensp;{'Generate Invoice'}
                                    </option>
                                    <option key={'key-quote-select'} value={'Quote'} selected={selectOptionType == "Quote"? true: false} >
                                        &ensp;{'Generate Quote'}
                                    </option>
                                    <option key={'key-quote-invoice-select'} value={'Invoice From Quote'} selected={selectOptionType == "Invoice From Quote"? true: false} >
                                        &ensp;{'Generate Invoice From Quote'}
                                    </option>
                            </Input>
                        </InputGroup>
                        
                        <br />
                        {selectOptionType == "Invoice From Quote"? 
                            <InputGroup>
                                <Input type="number" name={'quote_number'} placeholder={ 'Enter Quote Number...'}></Input>
                            </InputGroup>: 
                            <InputGroup>
                                <Select
                                    closeOnSelect={!stayOpen}
                                    multi
                                    onChange={this.handleSelectChange}
                                    options={teams}
                                    placeholder={placeholder}
                                    removeSelected={removeSelected}
                                    simpleValue
                                    value={value}
                                />
                            </InputGroup>
                        }
                        </FormGroup>
                        <br />
                        <Button>View</Button>
                    </Form>
                )}
            </div>
            
            <div id="editor"></div>
            <div id="content" className="mt4">
                {invoiceTeamId !== '' ? <Invoice teamsId={invoiceTeamId} invoiceNumber={this.state.invoiceNumber} isDownloadDatFound={this.isDataFoundForDownload} allControllerIdGet={this.allControllerIdGet} selectOptionType={selectOptionType} quoteControllersIds={quoteControllersIds}  /> : ''}
            </div><br />
            <div className="row justify-content-center align-items-center">
             {loading ? <Loader type="TailSpin" width={60} height={60} /> 
             :selectOptionType == "Quote" && invoiceTeamId !== "" ?
             <Form onSubmit={this.handleSubmitQuote} className="col-lg-5 col-md-8 col-sm-10 noprint">
             <FormGroup>
                 <br />
                 <InputGroup>
                 <Input type="email" name="email" placeholder="Enter Email Address..."></Input>
             </InputGroup>
             
             </FormGroup>
             <br />
             <Button>Share Quote</Button>
         </Form>:
         null
             }
            </div><br />
            {enableDownload &&
                <div className="mb5">
                    <Button className="secondary noprint" id="cmd" onClick={this.downloadDocument}>Download {selectOptionType}</Button>
                    <Button className="secondary noprint pay_print_btn" onClick={() => window.print()}>Print {selectOptionType}</Button>
                </div>
            }

        </div>)
    }
}

export default InvoiceForSupport



// WEBPACK FOOTER //
// ./src/components/pages/subscription/InvoiceForSupport.js